// 德语
export default {
  day: 'Tag',
  hour: 'Stunde',
  min: 'Minute',
  sesc: 'Sekunde',
  cancel: 'abbrechen',
  confirm: 'bestätigen',
  showMore: 'mehr anzeigen',
  hideMore: 'weniger anzeigen',
  per_sale: { 
    title: 'Die Vorverkaufsphase endet in {days} Tagen {hours} Stunden {mins} Minuten {secs} Sekunden',
    title1: 'Um am öffentlichen Verkauf teilzunehmen, ist es notwendig, zuerst das KYC abzuschließen',
    text: 'DLC kaufen',
    text1: 'Am KYC teilnehmen',
  },
  meau: {
    nav1: 'Was ist DeepLink?',
    nav2: 'Wie kaufen?',
    nav3: 'Weißbuch',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'Adresse:',
    link: 'Wallet verbinden',
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'Countdown für die erste Phase des öffentlichen Verkaufs:',
      text1: 'Der aktuelle KYC hat bereits begonnen',
      text2: 'Countdown bis zum Ende der Phase 5 des öffentlichen Verkaufs',
      text3: 'Countdown für die zweite Phase des öffentlichen Verkaufs:',
      text4: 'Der öffentliche Verkauf ist beendet',
      tip: 'Bitte stellen Sie sicher, dass Sie die KYC-Verifizierung abschließen, bevor Sie Tokens (DLC) kaufen',
      tip1: 'Bitte nicht mehrfach kaufen',
    },
    desc: {
      title: 'Deeplink besteht aus zwei Komponenten: DeepLink Protocol und Deeplink Software',
      left: {
        text: 'Alle Zahlungen werden mit DeepLink-Token durchgeführt!',
        text1: 'DeepLink Protocol ist ein dezentralisiertes AI-Cloud-Gaming-Protokoll,',
        text2: 'das AI- und Blockchain-Technologie kombiniert, um eine Technologie für die Spiel-Renderung mit ultra-niedriger Latenz zu bieten. DeepLink Software ist eine Fernsteuerungssoftware für Spiele und eine Cloud-Gaming-Plattform, die auf DeepLink Protocol basiert. Weitere Produkte, die auf DeepLink Protocol entwickelt wurden, umfassen eine Cloud-Cybercafé-Plattform, eine Blockchain-Cloud-Gaming-Konsole, eine tragbare Blockchain-Cloud-Gaming-Konsole und vieles mehr.',
        text3: '100% Secure & Verified',
        btn1: 'Einführung in das DeepLink Protocol',
        btn2: 'Einführung in die DeepLink Software',
      },
      right: {
        text1: 'Public Sale läuft gerade',
        text1_1: 'KYC läuft gerade',
        text1_2: 'Public Sale Phase {pre_num1} läuft gerade',
        // text2: 'DLC-Preis: 1DLC={price}USDT, verbleibende {days} Tage {hour} Stunden {min} Minuten',
        text2: 'DLC-Preis: 1DLC={price}USDT',
        text3: 'Die {pre_num}te Public Sale ist beendet',
        text4: 'Phase {pre_num1} beginnt bald',
        text5: 'Public Sale beginnt bald',
        text6: 'Bitte schließen Sie den KYC-Prozess ab, bevor Sie an der öffentlichen Verkauf teilnehmen. Vielen Dank für Ihre Zusammenarbeit.',
        // text7: 'Zusätzliche Belohnung von 10 % Token in der aktuellen Phase, die Belohnung wird in der nächsten Phase auf 5 % reduziert',
        text7: 'Zusätzliche Belohnung von 5 % Token in der aktuellen Phase, keine zusätzliche Belohnung in der nächsten Phase',
        text8: 'Treten Sie der Community bei und nehmen Sie am Gewinnspiel teil, um 10.000 USDT und DLC zu gewinnen',
        process: 'Abgeschlossen {process}%',
        btn1: 'An der KYC-Verifizierung teilnehmen',
        btn1_1: 'KYC genehmigt',
        text7_1: 'Das KYC der aktuellen Wallet wird überprüft, bitte warten Sie',
        text7_2: 'Das KYC der aktuellen Wallet wurde genehmigt!',
        text7_3: 'Das KYC der aktuellen Wallet wurde nicht genehmigt, bitte erneut einreichen!',
        text7_4: 'Das KYC der aktuellen Wallet wurde nicht eingereicht',
        btn2: 'DLC TOKEN kaufen',
        btn3: '5% Empfehlung-Link',
        btn3_1: '10% Empfehlung-Link',
        btn3_2: '15% Empfehlung-Link',
        btn3_3: '20% Empfehlung-Link',
      },
      success: 'Der Link wurde in die Zwischenablage kopiert',
      error1: 'Bitte verbinden Sie zuerst Ihre Wallet, um den exklusiven Einladungscode zu erhalten und Belohnungen zu gewinnen',
      error2: 'Wallet nicht verbunden, bitte verbinden Sie zuerst Ihre Wallet',
      error3: 'Die KYC-Verifizierung ist in Bearbeitung, bitte warten Sie, bis sie abgeschlossen ist, bevor Sie den Kauf tätigen',
      error4: 'Die KYC-Verifizierung ist fehlgeschlagen, bitte reichen Sie die KYC-Verifizierungsinformationen erneut ein, um zu kaufen',
      error5: 'Fehler beim Abrufen der KYC-Verifizierungsinformationen, bitte versuchen Sie es später erneut',
      error6: 'Bitte warten Sie, bis der Countdown endet, um den Kauf zu tätigen.',
      error7: 'Phase 3 ist beendet, bitte warten Sie auf den Beginn von Phase 4',
      tip1: 'DLC noch nicht verteilt',
      tip2: 'DLC wurde an die Wallet des Nutzers verteilt',
      tip3: 'Zahlung erfolgreich',
    },
    rule: {
      title: 'Regelbeschreibung',
      text1: 'Die KYC-Verifizierung ist obligatorisch und erfordert die Vorlage von Identifikationsdokumenten wie Personalausweis, Reisepass oder Führerschein. Einwohner von Singapur, China, den USA, Südkorea und einigen anderen Ländern können nicht am IDO teilnehmen.',
      // text2: 'Nach dem Ende des öffentlichen Verkaufs wird das DLC innerhalb von 7 Tagen an den DEX-Börsen und innerhalb von 15 Tagen an den CEX-Börsen notiert. Die Adresse des Smart Contracts für den DLC-Token auf der BSC-Kette lautet: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text2: 'Acht Börsen haben bestätigt, dass sie DLC listen werden, und wir warten darauf, dass eine große Börse den Listing-Zeitplan festlegt. Sobald die Zeit bestätigt ist, werden alle Börsen DLC am selben Tag listen. Wir werden das Datum im Voraus auf dem offiziellen X-Konto bekannt geben. Die BSC-Ketten-Smart-Contract-Adresse des DLC-Tokens: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: 'Der Kauf von 20.000.000 DLC berechtigt Sie zu einer DeepLink-Heim-GPU-Spiel-Mining-Maschine im Wert von 1500 Dollar. Dieses Angebot ist auf Japan und Europa beschränkt, und die Versanddetails werden per E-Mail mitgeteilt.',
      text3_btn: 'Erfahren Sie mehr über die Heim-GPU-Spiel-Mining-Maschine',
      text4: 'Der öffentliche Verkauf wird 48 Stunden nach dem Start geschlossen, und der Preis für jeden DLC beträgt 0,003 USDT. 40% der Tokens bleiben entsperrt, die restlichen 60% werden ab dem 31. August 2024 schrittweise freigegeben. Bitte beachten Sie, dass: 40% des DLC werden wenige Minuten nach dem Kauf an die von Ihnen angegebene Wallet-Adresse übertragen, die restlichen 60% werden bei Ablauf der Sperrfrist an Ihre Wallet-Adresse übertragen.',
      text5: 'Der Public Sale wird in 5 Phasen durchgeführt,',
      table: {
        table1_text1: 'Phase',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'Menge an DLC',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: '300,000,000DLC',
        table2_text5: '450,000,000DLC',
        table2_text6: '1,871,700,000DLC',
        table3_text1: 'Preis von DLC (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: 'Bonus',
        table4_text2: 'Zusätzlicher Bonus von 20% DLC',
        table4_text3: 'Zusätzlicher Bonus von 15% DLC',
        table4_text4: 'Zusätzlicher Bonus von 10% DLC',
        table4_text5: 'Zusätzlicher Bonus von 5% DLC',
        table4_text6: 'NO',
        table5_text1: 'Menge',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: '5,615,100 USDT'
      }
    },
    ecology: {
      title: 'Überblick über das DeepLink Protocol Ökosystem',
      block1_title: 'DeepLink Software',
      block1_text1: 'Die Hauptfunktion der DeepLink Software ist die Fernsteuerung und die Cloud-Gaming-Plattform',
      block1_text2: 'DeepLink Protocol umfasst DeepLink Protocol und DeepLink Software. Im Kern bietet DeepLink Software Fernsteuerungs- und Cloud-Gaming-Funktionen, die es den Nutzern ermöglichen, an Fernspielen, Fernarbeit und dem Zugriff auf cloudbasierte Spieleservices teilzunehmen. Derzeit hat diese Software Nutzer in 110 Ländern, mit über 400.000 Downloads und mehr als 200.000 erstellten Wallets weltweit.',
      block1_btn1: 'Mehr über die DeepLink Software erfahren',
      block2_title: 'Cloud-Internetcafés und Cloud-eSports',
      block2_text1: 'Das Cloud-Internetcafé stellt ein innovatives Modell für Internetcafé- und eSports-Dienste dar, das die ultra-niedrige Latenz-Rendering-Technologie von DeepLink Protocol nutzt.',
      block2_text2: 'In dieser Konfiguration werden Spiele und Anwendungen auf Cloud-GPU-Servern statt auf lokalen Computern gehostet, was es den Nutzern ermöglicht, über Cloud-Dienste auf Spiele zuzugreifen und zu spielen, ohne eine leistungsstarke lokale GPU-Workstation zu benötigen. Cloud-Internetcafés auf Basis der DeepLink-Technologie werden in mehreren Ländern wie Südkorea, China, Japan, Vietnam, den Philippinen und Indien eingesetzt, mit Beteiligung von HYCONS, ZESTCLOUD, GLOWSTEAM und TIKEREN. Ein operativer Fall besteht bereits in Südkorea.',
      block2_btn1: 'Video ansehen',
      block2_btn2: 'Mehr über Cloud-Internetcafés erfahren',
      block3_title: 'Blockchain-basierte Cloud-Gaming-Konsole',
      block3_text1: 'Was ist eine Cloud-Gaming-Konsole?',
      block3_text2: 'Die blockchain-basierte Cloud-Gaming-Konsole stellt einen Durchbruch in der Spielehardware dar und bietet eine hohe FPS-Bildwiederholrate für ein nahtloses eSports-Spielerlebnis. Die von der HKC-Gruppe entwickelte TIKEREN-Cloud-Gaming-Konsole nutzt die ultra-niedrige Latenz-Rendering-Technologie von DeepLink und verbindet sich in Echtzeit mit Cloud-GPU-Servern, um die Spiel-Rendering-Leistung zu verbessern.',
      block3_btn1: 'Mehr über die blockchain-basierte Cloud-Gaming-Konsole erfahren',
      block4_title: 'Blockchain-basierte Cloud-Gaming-Handheld-Konsole',
      block4_text1: 'Was ist eine Cloud-Gaming-Handheld-Konsole?',
      block4_text2: 'Die Cloud-Gaming-Handheld-Konsole, die auf der ultra-niedrigen Latenz-Rendering-Technologie von DeepLink basiert, bietet eine kostengünstigere Option im Vergleich zu herkömmlichen Handheld-Konsolen und liefert gleichzeitig ein flüssiges AAA-Spielerlebnis. Durch die Verbindung zu Cloud-GPU-Servern für das Echtzeit-Game-Rendering werden die Kosten der Handheld-Konsole um 70% reduziert.',
      block4_btn1: 'Mehr über die blockchain-basierte Cloud-Gaming-Handheld-Konsole erfahren',
    },
    coverage: {
      title: 'Weltweite Benutzerverteilungskarte der DeepLink-Software',
      text: 'Gesamtzahl der DeepLink-Benutzer:'
    },
    track: {
      title: 'DeepLink Protocol ist eine Kombination aus DePIN+KI+Spiel',
      text: 'Gehört zu den aktuell heißesten Bereichen der Blockchain-Industrie',
      block1_title: 'Wie groß ist der Markt von DeepLink?',
      block1_text: 'Eine der Funktionen von DeepLink kann als dezentralisierte Version von XBOX und PlayStation verstanden werden. Bis Ende 2023 erreichten die weltweiten Verkaufszahlen der PS5 von Sony 50 Millionen Einheiten und die der Xbox Series X|S 30 Millionen Einheiten. Die Gesamtkäufe von PS und Xbox überstiegen 200 Millionen Einheiten, was zeigt, dass der Markt für hochklassige AAA-Spiele enorm ist.',
      block2_title: 'DeepLink bedient, genau wie XBOX und PlayStation, auch hochklassige AAA-Spieler, aber das Geschäftsmodell ist völlig anders',
      block2_text: 'Die Spieler von DeepLink müssen keine hochklassigen Spielekonsolen kaufen. Sie müssen lediglich die DeepLink-Software herunterladen oder eine Blockchain-basierte Cloud-Gaming-Konsole oder eine Blockchain-basierte tragbare Cloud-Gaming-Konsole kaufen. Die Spieler können ein AAA-Spielerlebnis ähnlich dem von XBOX und PlayStation genießen, sparen dabei jedoch 80 % der Hardwarekosten.',
      block3_title: 'Miner bieten hochklassige AAA-Spielekonsolen an, die Windows-Systeme sind und alle Windows-AAA-Spiele unterstützen.',
      block3_text: 'Die Spielekonsolen der Miner können zu Hause oder in Rechenzentren aufgestellt werden. Die Konsolen von Xbox und PlayStation können nur von ihren Eigentümern verwendet werden und können nicht an andere vermietet werden, was zu einer niedrigen Nutzungseffizienz und einer großen Verschwendung von Ressourcen führt. Die Mining-Maschine von DeepLink kann von jedem genutzt werden, wodurch die Nutzung der Hardware-Ressourcen verbessert und ein neues Geschäftsmodell geschaffen wird.',
      block4_title: 'Miner, die Mining-Maschinen zur Verfügung stellen, können Belohnungen in Form von DLC-Token erhalten',
      block4_text: 'Dies ermutigt mehr Miner, Mining-Maschinen zur Verfügung zu stellen. Benutzer müssen mit DLC-Token für Spielzeit bezahlen, wodurch die Nutzungsszenarien von DLC erweitert und die Anzahl der Token-Inhaber erhöht wird. Das potenzielle Nutzermarktvolumen übersteigt eine Milliarde Menschen.',
      table: {
        table1_text1: 'Detaillierter Vergleich',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'AAA-Spiele spielen',
        table2_text2: 'Benutzer müssen keine Hardware kaufen, sondern nur die DeepLink-Software herunterladen',
        table2_text3: 'Benutzer müssen Hardware kaufen',
        table2_text4: 'Benutzer müssen Hardware kaufen',
        table3_text1: 'Spielekonsole',
        table3_text2: 'Kann für $DLC vermietet werden, kann mehr als 12 Stunden pro Tag vermietet werden, Amortisation in 10 Monaten',
        table3_text3: 'Kann nur vom Besitzer verwendet werden, kann nicht vermietet werden, Nutzung 2-4 Stunden pro Tag, Hardware-Ressourcen werden verschwendet',
        table3_text4: 'Kann nur vom Besitzer verwendet werden, kann nicht vermietet werden, Nutzung 2-4 Stunden pro Tag, Hardware-Ressourcen werden verschwendet',
        table4_text1: 'Handheld-Konsole',
        table4_text2: 'Unterstützt, kann an jede Hardware angeschlossen werden',
        table4_text3: 'Keine dedizierte Handheld-Konsole',
        table4_text4: 'Unterstützt, kann nur an PS5 angeschlossen werden',
        table5_text1: 'Cloud-Gaming-Konsole',
        table5_text2: 'Unterstützt',
        table5_text3: 'Unterstützt nicht',
        table5_text4: 'Unterstützt nicht',
        table6_text1: 'Cloud-Internetcafé',
        table6_text2: 'Unterstützt',
        table6_text3: 'Unterstützt nicht',
        table6_text4: 'Unterstützt nicht',
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: 'Teamvorstellung',
      btn4: 'Wirtschaftsmodell'
    },
    faqs: {
      title: 'FAQS',
      text: 'Sie haben vielleicht Fragen, wir haben die Antworten.',
      ques_title1: '1. Was ist der Public Sale?',
      ques_text1: 'Während des Public Sale wird eine begrenzte Anzahl von Token zu einem festgelegten Preis an Personen verkauft, die frühzeitig teilnehmen möchten. Dies ist eine großartige Gelegenheit, Teil von DeepLink zu werden, bevor der eigentliche Token-Launch erfolgt. Durch die Teilnahme am Public Sale können Sie Token zu einem frühen Preis erwerben, bevor sie öffentlich angeboten werden. Daher kann der Public Sale als eine potenzielle Gelegenheit betrachtet werden, Token zu kaufen, bevor sie in Umlauf kommen und an Börsen notiert werden.',
      ques_title2: '2. Warum führen wir einen Public Sale durch?',
      ques_text2_1: 'Wir führen den Public Sale durch, um eine starke Gemeinschaft von $DLC-Inhabern aufzubauen, unsere Plattform zu verbessern und Mittel zu beschaffen, um mehr Spieler in unser Ökosystem zu locken.',
      ques_text2_2: 'Die während des Public Sale gesammelten Mittel werden kontinuierlich in die DeepLink-Produkte reinvestiert, um neue Funktionen einzuführen und die Benutzerbasis durch Marketingaktivitäten zu erweitern. Dies wird uns ermöglichen, unsere Markteinführungsstrategie vor dem Start des $DLC-Token umzusetzen.',
      ques_text2_3: 'Unser Ziel ist es, 1.000.000.000 Menschen zur Nutzung von DeepLink zu bewegen, was umfangreiche Nutzungsszenarien für den $DLC-Token bietet und den langfristigen Erfolg des $DLC-Token sichert. Der $DLC-Token wird an DEX- und CEX-Börsen gelistet, was das Wachstum des DeepLink-Ökosystems weiter vorantreiben wird.',
      ques_text2_4: 'Treten Sie jetzt dem DeepLink Public Sale bei und werden Sie Teil von DeepLink!',
      ques_title3: '3. Was ist der Unterschied zwischen DeepLink Protocol und DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol ist ein dezentralisiertes AI-Cloud-Gaming-Protokoll, das AI- und Blockchain-Technologien kombiniert, um eine Technologie für das Spielen mit ultra-niedriger Latenz zu bieten.',
      ques_text3_2: 'DeepLink Software ist eine Fernsteuerungssoftware für Spiele und eine Cloud-Gaming-Plattform, die auf DeepLink Protocol basiert.',
      ques_text3_3: 'Weitere Produkte, die auf DeepLink Protocol entwickelt wurden, umfassen eine Cloud-eSports-Café-Plattform, eine Blockchain-basierte Cloud-Gaming-Konsole und eine Blockchain-basierte tragbare Cloud-Gaming-Konsole, unter anderem.',
      ques_title4: '4. Was ist innovativ am DeepLink Protocol?',
      ques_text4: 'DeepLink löst die Kernprobleme der Cloud-Gaming-Branche durch den Einsatz von Blockchain- und AI-Technologie und zieht Miner und ungenutzte GPU-Maschinen durch ein Token-Anreizsystem an. Es zieht auch ungenutzte Bandbreite an, um die beiden zentralen Herausforderungen der Cloud-Gaming-Branche zu lösen. Die AI-Technologie verbessert die Spielgrafik und damit die Benutzererfahrung.',
      ques_title5: '5. Was ist das $DLC Token?',
      ques_text5: 'Das $DLC Token ist das einzige Zahlungsmittel im DeepLink-Ökosystem. Benutzer müssen mit $DLC Token bezahlen, um Cloud-Gaming-Zeit zu kaufen, Cloud-Gaming-Computer zu mieten, Lizenzen zu erwerben usw.',
      ques_title6: '6. Wer sind die Zielkunden von DeepLink Protocol?',
      ques_text6_1: '1) AAA-Spieleunternehmen: Hilft bei der Umwandlung von AAA-Spielen in Cloud-Spiele, sodass AAA-Spiele auf jedem Gerät mit niedriger Leistung, einschließlich Mobiltelefonen, betrieben werden können, und vergrößert die Nutzerbasis von AAA-Spielen um mehr als das 10-fache.',
      ques_text6_2: '2) Internetcafés und eSports-Hotels: Hilft bei der Modernisierung traditioneller Internetcafés und der Umwandlung in Cloud-Internetcafés, reduziert die Hardware-Investitionen um mehr als 80 % und erhöht den Nettogewinn innerhalb von 4 Jahren um das 3-fache.',
      ques_text6_3: '3) Hersteller von Cloud-Gaming-Konsolen: Hersteller können DeepLink Protocol integrieren, wodurch AAA-Spiele mit einer Low-End-CPU-Konfiguration und einem High-End-Gaming-Display gespielt werden können, was den Spielern 80 % der Hardware-Investitionen erspart.',
      ques_text6_4: '4) Hersteller von tragbaren Cloud-Gaming-Konsolen: Hersteller können DeepLink Protocol integrieren, wodurch der Preis der tragbaren Konsole 30 % des Preises einer herkömmlichen Konsole beträgt und die Spieleleistung mehr als das 5-fache der herkömmlichen tragbaren Konsole beträgt.',
      ques_title7: '7. Wer sind die Zielkunden von DeepLink Software?',
      ques_text7: 'Es gibt weltweit 3 Milliarden potenzielle persönliche Spieler, die es Spielern ermöglichen, AAA-Spiele auf ihren Mobiltelefonen, leistungsschwachen Computern oder Macs und Fernsehern zu genießen.',
      ques_title8: '8. Gibt es eine Sperrfrist?',
      ques_text8: '40 % der gekauften DLC-Token sind nicht gesperrt, 60 % werden ab dem 31. August 2024 über einen Zeitraum von 150 Tagen freigeschaltet, wobei alle 30 Tage 10 % freigeschaltet werden.',
      ques_title9: '9. Wie kauft man $DLC?',
      ques_text9: 'Nehmen Sie zuerst an der KYC teil, übermitteln Sie Ihre persönlichen Informationen und nach der Genehmigung können Sie am Kauf von $DLC teilnehmen, wenn der Public Sale beginnt.',
    },
    buy: {
      title: 'Wie kaufen?',
      step1: 'Schritt 1:',
      step1_text: 'Verbinden Sie Ihre Metamask- oder Trust Wallet',
      step2: 'Schritt 2:',
      step2_text: 'Bestätigen Sie die Transaktion. Sie können USDT verwenden, um $DLC zu kaufen',
      step3: 'Schritt 3:',
      step3_text: 'Sie können Ihr $DLC nach dem Ende des öffentlichen Verkaufs einfordern',
      btn1: 'Brauchen Sie Hilfe',
      btn2: 'DLC kaufen',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'Die Marktkapitalisierung mehrerer Token im DePIN-Sektor ist nach ihrer Notierung an den Börsen weiter gewachsen.',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'DeepLink Software hat ein potenzielles Nutzerpotenzial von über einer Milliarde, was eine große Anzahl von Web2-Nutzern in die Web3-Welt bringen wird. Die potenzielle Anzahl der $DLC-Inhaber übersteigt eine Milliarde Menschen.',
      text3: 'Es gibt weltweit über 200.000 eSports-Internetcafés. In Zukunft werden mehr als 50 % der traditionellen Internetcafés in Cloud-Internetcafés umgewandelt. Die Technologie der Cloud-Internetcafés hat ein großes Anwendungspotenzial, und jedes Cloud-Internetcafé muss $DLC für Zahlungen verwenden, was zu einem massiven Einsatz von $DLC führen wird.',
      text4: 'Basierend auf den Verkaufszahlen von XBOX und PS5 wird die Anzahl der Benutzer, die Blockchain-basierte Cloud-Gaming-Konsolen und tragbare Cloud-Gaming-Konsolen kaufen, über 100 Millionen übersteigen, was $DLC einen enormen Wert bringen wird.'
    },
    report: {
      title: 'DeepLink in den Medien'
    },
    prompt: {
      title: 'Hinweiserklärung',
      text1: 'DeepCloudX.PTE.LTD betreibt die Website deeplink.cloud ("die Plattform").',
      text2: 'Durch die Nutzung dieser Plattform akzeptieren Sie unsere Nutzungsbedingungen, Datenschutzrichtlinie, Cookie-Richtlinie und den DLC-Token-Verkaufsvertrag. In Ihrer Gerichtsbarkeit können Kryptowährungen möglicherweise nicht reguliert sein. Der Wert von Kryptowährungen kann steigen oder fallen. Gewinne können durch Kapitalertragssteuer oder andere in Ihrer Gerichtsbarkeit geltende Steuern beeinflusst werden. Nichts auf dieser Website sollte als Angebot oder Empfehlung zum Kauf, Verkauf oder zur Investition ausgelegt werden. Sie sind allein dafür verantwortlich zu bestimmen, ob ein Kauf oder eine damit verbundene Transaktion für Sie geeignet ist, basierend auf Ihren persönlichen Zielen, Ihrer finanziellen Situation und Ihrer Risikotoleranz.',
      text3: 'Sie sollten vertrauenswürdige, lizenzierte Rechtsberater und Berater konsultieren, um rechtliche, steuerliche, versicherungsbezogene oder geschäftliche Ratschläge zu erhalten. DLC garantiert keine Leistung, Ergebnisse oder Kapitalrendite für eine Kryptowährung auf dieser Website. Durch den Zugriff auf diese Website und jede ihrer Seiten stimmen Sie zu, an den DLC-Verkaufsvertrag gebunden zu sein. Der Kauf von Kryptowährungen birgt Risiken und kann zu einem teilweisen oder vollständigen Verlust führen.'
    }
  },
  dialog1: {
    title: 'KYC-Informationen einreichen',
    text1: 'Identitätsinformationen hochladen:',
    text2: 'Foto mit dem Identitätsdokument hochladen:',
    text3: 'Vorderseite des Personalausweises, Reisepasses oder Führerscheins',
    text4: 'Das Gesicht und die Identitätsinformationen müssen deutlich sichtbar sein',
    text5: 'Menge an DLC, die Sie kaufen möchten:',
    text6: 'Zertifizierte Wallet-Adresse:',
    text7: 'Sie erhalten eine Belohnung von 1000 DLC nach erfolgreicher KYC-Überprüfung, und die während der Public Sale gesperrten DLC werden ebenfalls an diese Wallet-Adresse gesendet',
    text7_1: 'Nur diese Adresse kann nach der KYC-Überprüfung zum Kauf von DLC verwendet werden, keine Exchange-Adresse',
    text8: 'Wo eine DLC-Wallet-Adresse in der DBC-Kette erstellen?',
    text9: 'Oder',
    text10: 'E-Mail-Adresse eingeben:',
    text11: 'Bestätigungscode erhalten',
    text12: 'Bestätigungscode eingeben:',
    text13: 'Erneut senden in {secs} Sekunden',
    text14: '(Maximal 20.000.000 DLC, Sie können nur die Menge kaufen, die bei der KYC-Überprüfung genehmigt wurde, wenn die Public Sale beginnt)',

    success1: 'Verifizierungscode gesendet!',
    success2: 'Informationen erfolgreich übermittelt, Prüfung ausstehend',
    error1: 'Sie müssen eine Bilddatei auswählen!',
    error2: 'Die Bilddatei darf nicht leer sein!',
    error3: 'Der Benutzername darf nicht leer sein!',
    error4: 'Die Wallet-Adresse darf nicht leer sein!',
    error5: 'Die E-Mail darf nicht leer sein!',
    error6: 'Bitte geben Sie eine gültige E-Mail-Adresse ein!',
    error7: 'Der Verifizierungscode darf nicht leer sein!',
    error8: 'Fehler beim Senden des Verifizierungscodes, bitte versuchen Sie es später erneut!',
    error9: 'Hinzufügen fehlgeschlagen',
    error10: 'Verifizierungscode falsch, bitte versuchen Sie es erneut',
    error11: 'Fehler bei der Abfrage der E-Mail-Informationen',
    error12: 'Die Kaufmenge darf 20.000.000 nicht überschreiten',
    error13: 'Der Verifizierungscode ist abgelaufen, bitte erneut anfordern',
    error14: 'Informationen erfolgreich übermittelt, Fehler beim Senden der Bestätigungs-E-Mail',
    error15: 'Wenn Sie die E-Mail nicht erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner',
    error16: 'Das Bild darf nicht größer als 5 MB sein',
    error17: 'Bitte senden Sie die KYC-Verifizierungsdaten nicht wiederholt',
    tip1: '(Freundlicher Hinweis: Die persönlichen Informationen werden nur für die KYC-Verifizierung verwendet und nicht für andere Zwecke)',
  },
  dialog2: {
    title: 'DLC kaufen',
    text1: 'Menge an DLC, die Sie kaufen möchten:',
    text2: 'Sie müssen mindestens 150.000 DLC kaufen',
    text3: 'Wählen Sie die zu zahlende Kryptowährung:',
    text4: 'Geben Sie die Adresse der DLC-Wallet auf der DBC-Kette ein:',
    text5: '40 % der DLC werden innerhalb weniger Minuten an diese Wallet-Adresse übertragen, und die restlichen 60 % werden an diese Wallet-Adresse übertragen, wenn die Sperrfrist abläuft',
    text6: 'Wo eine DLC-Wallet-Adresse in der DBC-Kette erstellen?',
    text7: 'Oder',
    text8: 'Entsprechender USDT-Betrag:',
    text9: 'Wählen Sie die Zahlungsmethode:',
    text9_1: 'Mit der aktuell verbundenen Wallet bezahlen',
    text9_2: 'Mit QR-Code bezahlen',
    error1: 'Die Menge an DLC darf nicht leer sein',
    error2: 'Bitte geben Sie eine Zahl ein',
    error3: 'Die eingegebene Zahl muss größer als 50.000 sein',
    error4: 'Die Wallet-Adresse darf nicht leer sein',
    error5: 'Fehler beim Erstellen der Bestellung',
    success1: 'Zahlung erfolgreich, die DLC werden in wenigen Minuten an Ihre Wallet-Adresse übertragen, bitte überprüfen!',
    success2: 'Zahlung über den Weiterleitungslink erfolgreich, die DLC werden in wenigen Minuten an Ihre Wallet-Adresse übertragen, bitte überprüfen!',
    error6: 'Die Menge an USDT darf nicht leer sein',
    error7: 'Die Menge an USDT darf nicht weniger als 150 sein',
    error8: 'Die Menge an USDT darf nicht mehr als 60.000 sein',
    error9: 'Der Zahlungsbetrag stimmt nicht mit dem gespeicherten Betrag überein, bitte kontaktieren Sie den Administrator, um zu bestätigen, ob dies korrekt ist',
  },
  dialog3: {
    title: 'Einführung in die All-in-One-Konsole',
    text1: '1. Was ist eine Cloud-Gaming-All-in-One-Konsole?',
    text2: 'Die Cloud-Gaming-All-in-One-Konsole bietet im Vergleich zu herkömmlichen All-in-One-Geräten eine Anzeige mit hoher FPS-Bildwiederholrate und sorgt so für ein flüssiges Spielerlebnis. Die TIKEREN Cloud-Gaming-All-in-One-Konsole der HKC Group basiert auf der DeepBrainChain + DeepLink-Technologie und kann in Echtzeit eine Verbindung zu leistungsstarken entfernten GPUs herstellen, um Spiele zu rendern und zu berechnen. Das Gerät ist mit einem integrierten Windows-System ausgestattet und kann für normale Büroarbeiten und Unterhaltung verwendet werden, indem Spiele von Ihrer eigenen leistungsstarken GPU über DeepLink gestreamt werden. Wenn keine leistungsstarke GPU zur Verfügung steht, können Sie über DeepLink eine Verbindung zu einer entfernten leistungsstarken GPU herstellen, um AAA-Spiele zu spielen, und zahlen dabei eine bestimmte Menge an DLC-Token pro Stunde.',
    text3: '2. Präsentation der TIKEREN-Konsole',
    table: {
      th: {
        text1: 'Projekt',
        text2: '27 Zoll',
        text3: '31.5 Zoll',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 Zoll',
        text3: '31.5 Zoll',
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Oben, unten, links, rechts, 90°-Drehung, Höhenverstellung',
        text3: 'Oben, unten, links, rechts, 90°-Drehung, Höhenverstellung',
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Verstanden'
  },
  dialog4: {
    title: 'Einführung in die tragbare Cloud-Gaming-Konsole',
    text1: '1. Was ist eine tragbare Cloud-Gaming-Konsole?',
    text2: 'Die tragbare Cloud-Gaming-Konsole unterscheidet sich von herkömmlichen Handheld-Konsolen, da sie auf der ultra-niedrigen Latenz-Rendering-Technologie von DeepLink basiert. Dadurch kann sie in Echtzeit eine Verbindung zu GPU-Servern in der Cloud herstellen, um leistungsstarke Spiele zu rendern. Dies senkt die Kosten der tragbaren Konsole um 70 % und ermöglicht ein flüssiges AAA-Spielerlebnis. Die tragbare Konsole verfügt über integriertes Google Play, um Android-Spiele herunterzuladen, und kann Spiele von Ihrer eigenen leistungsstarken Windows-GPU/PS/XBOX streamen. Wenn Sie keine leistungsstarke GPU besitzen, können Sie über DeepLink eine Verbindung zu einer leistungsstarken entfernten GPU herstellen, um AAA-Spiele zu spielen, wobei eine bestimmte Menge DLC-Token pro Stunde zu zahlen ist.',
    text3: '2. Präsentation der blockchain-basierten Cloud-Gaming-Konsole',
    btn: 'Verstanden'
  },
  dialog5: {
    title: 'Einführung in die Heim-GPU-Spiele-Mining-Maschine',
    text1: '1. Was ist eine Heim-GPU-Spiele-Mining-Maschine?',
    text2: 'Die GPU-Spiele-Mining-Maschine ist mit einer NVIDIA 4070 Super GPU, einem Intel i7-13700F CPU, 32 GB RAM und 2 TB SSD-Speicherplatz ausgestattet. Sie verfügt über die DeepLink-Mining-Software und ein Verwaltungssystem. Jeder kann diese Maschine zu Hause aufstellen und DLC-Belohnungen verdienen. Jährlich werden 1 Milliarde DLC-Token als Belohnungen für alle Spiele-Mining-Maschinen verteilt, unabhängig davon, ob die Maschine von Benutzern gemietet wird oder nicht. Wenn die GPU-Spiele-Mining-Maschine zur Vermietung eingestellt wird, können DLC-Belohnungen und Mieteinnahmen in DBC erzielt werden. Wenn keine Benutzer die Maschine mieten, können andere Token gemined werden, wodurch rund um die Uhr Einnahmen erzielt werden können.',
    text3: '2. Präsentation der Heim-GPU-Spiele-Mining-Maschine',
    text4: '3. Technische Daten',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'Verstanden'
  }
}